import { http } from "../../utils";

export async function uploadImage(formData) {
  try {
    const { data: response } = await http("/public/upload-s3/file", {
      data: formData,
    });

    return response;
  } catch (error) {
    console.log(error, "error");
  }
}
